<template>
  <div>
    <div class="bg">
      <div></div>
      <Nav @getTime="getTime" title="品牌评估"/>

      <div style="display: flex;flex-direction: column;justify-content: space-between;height: 84%;">
        <div style="height: 50%" class="flex-top">
          <div class="flex-top-child ">
            <div class="backGround-line">品牌维度排名</div>
            <div id="radarChart" style="width: 100%;height: 100%;"></div>
          </div>
          <div class="flex-top-child">
            <div class="backGround-line">品牌综合指数</div>
            <div id="contrastChart" style="width: 100%;height: 100%;"></div>
          </div>
          <div style="width: 20%;background-color:rgb(17, 27, 39);border-radius: 12px;">
            <div>
              <el-button icon="el-icon-plus" @click="taskadd" style="background-color:rgb(34,53,76);width: 100%;">
                新增
              </el-button>
            </div>
            <div class="selected-container">
              <h4>对比区域：</h4>
              <div v-if="selectedItems.length === 0" class="placeholder">
                暂无选中项
              </div>
              <div v-else class="selected-list">
                <div
                    v-for="(item, index) in selectedItems"
                    :key="item.value"
                    class="selected-item">
                  <span>{{ item.name }}</span>
                  <el-button
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="removeSelectedItem(index)"
                      style="margin-left: 10px; background-color: #291111; color: white"
                  ></el-button>
                </div>
              </div>
            </div>
            <div style="">
              <el-button @click="startContrast">开始对比</el-button>
            </div>
          </div>
        </div>
        <div style="height: 50%;">
          <div style="height: 100%;" class="flex-top">
            <div class="chart-panel  chart-width">
              <div class="backGround-line">热议品牌话题</div>
              <div id="wordCloudChart" style="width: 100%;height: 100%;"></div>
            </div>
            <div class="chart-panel chart-panel-width">
              <div class="panel-header">
                <div class="backGround-line">品牌质量指数</div>
                <div class="chart-filters">
                  <button v-for="(i,index) in listArr" :key="index" class="filter-btn"
                          :class="{ active: categoryFilter === i.type }"
                          @click="contrast(i)">{{ i.title }}
                  </button>
                </div>
              </div>
              <div style="width: 100%;height: 90%;">
                <div id="thanChart" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        direction="rtl"
        style="z-index: 99999999999"
        size="20%"
        :with-header="false">
      <div class="drawer-content">
        <div class="backGround-line" style="font-size: 20px;padding: 10px">目的地品牌</div>
        <div class="grid-left-elDrawer">
          <el-button
              v-for="item in compareRegions"
              :key="item.value"
              :class="{ active: selectedItems.includes(item) }"
              @click="toggleSelect(item)"
              :disabled="selectedItems.length >= 5 && !selectedItems.includes(item)"
          >
            {{ item.name }}
          </el-button>
        </div>

        <div class="selection-count">
          已选中：{{ selectedItems.length }} / 5个
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import Nav from '_c/Nav/Nav.vue'
import * as echarts from 'echarts'

import 'echarts-wordcloud'
import {
  brandEvaluationCompareRegionList,
  brandEvaluationBrandComprehensiveIndex,
  brandEvaluationGetBrandIndex,
  brandEvaluationGetBrandDimensionRank,
  brandEvaluationGetBrandKeywordsCloud
} from '@/request/brandEvaluation/brandEvaluation'

export default {
  components: {
    Nav
  },
  data() {
    return {
      drawer: false,
      compareRegions: [], // 对比区域的数据
      selectedItems: [], // 存储选中的项
      chart_1: null,// 品牌综合指数
      chart_2: null, // 品牌各种参数对比
      chart_3: null, // 品牌维度排名
      chart_4: null, // 热议品牌话题
      nameList: [], // 存储的名字
      nameid: [], // 名字的id
      ComprehensiveIndex: [], // 品牌综合指数数据
      getBrandIndex: [],// 各类品牌的数据
      // seriesNameFirst1: '',
      // seriesNameFirst2: '',
      dataTime: {
        regionIds: '2,3'
      }, // 选择的时间
      listArr: [{title: '景点知名度', type: 1}, {title: '景点质量', type: 2}, {
        title: '景点个性',
        type: 3
      }, {title: '景点价值与形象', type: 4}, {title: '消费者情感分析', type: 5}],
      index: '',// 用来判断是否需要加类的
      text: '',// 对比的种类名称
      categoryFilter: 1,
    }
  },
  methods: {
    // 综合指数
    Chart1() {
      this.chart_1 = echarts.init(document.getElementById('contrastChart'));
      brandEvaluationBrandComprehensiveIndex().then(res => {
        this.ComprehensiveIndex = res.data.data
        var legend = this.ComprehensiveIndex.map(item => item.name)
        var colors = [
          "#FF5733",
          "#33FF57",
        ];
        // 时间段
        var xAxisData = this.ComprehensiveIndex[0].list.map(item => {
          return item.date
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              type: 'line',
              itemStyle: {color: colors[i]},
              label: {show: false},
              data: this.ComprehensiveIndex[i].list.map(item => {
                return item.index        // 对应的值
              })
            }
            list.push(obj)
          }
          return list
        }
        this.chart_1.setOption({
          grid: {
            top: 70,
            bottom: 70,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          series: updateChart()
        })
      })
    },
    // 品牌知名度质量获得感
    Chart2() {
      this.chart_2 = echarts.init(document.getElementById('thanChart'));
      brandEvaluationGetBrandIndex().then(res => {
        var legend = res.data.data.map(item => item.name)
        var colors = [
          "#FF5733",
          "#33FF57",
          '#0f74fa',
          '#060351',
          '#f6d806',
        ];
        // 时间段
        var xAxisData = res.data.data[0].list.map(item => {
          return item.date
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              data: res.data.data[i].list.map(item => {
                return item.index
              }),
              type: 'bar',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: colors[i]},
                  {offset: 1, color: 'rgba(255, 255, 255, 0)'}
                ])
              }
            }
            list.push(obj)
          }
          return list
        }
        this.chart_2.setOption({
          backgroundColor: 'transparent',
          legend: {
            data: legend,
            left: "50%", // 图例组件离容器左侧的距离
            top: "2%",  // 图例组件离容器上侧的距离
            itemWidth: 8, // 图例组件的宽度
            itemHeight: 8, // 图例组件的高度
            icon: "stack", //icon 长方形 circle 圆形 arrow箭头型 diamond菱形
            textStyle: {
              color: colors, //自定义颜色
              fontSize: 12
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisTick: {
                alignWithLabel: true
              },
              // 设置所有标签都显示
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: '#C5D6E6'
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#C5D6E6'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(217,231,255,0.3)'
                }
              }
            }
          ],
          series: updateChart()
        })
      })
    },
    // 品牌维度排名
    Chart3() {
      this.chart_3 = echarts.init(document.getElementById('radarChart'))
      brandEvaluationGetBrandDimensionRank().then(res => {
        console.log(res)
        // 景点的数量
        const dataName = res.data.data.series.map(item => {
          return item.name
        })
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 景点各个配套设施
        const scenicFacilities = res.data.data.dimensions.map(item => (
            {
              name: item.name,
            }
        ))
        const updateChart = () => {
          const list = []
          for (let i = 0; i < dataName.length; i++) {
            const obj = {
              type: 'radar',
              symbolSize: 3,
              animation: true,
              lineStyle: {
                color: colors[i],
                width: 1,
              },
              itemStyle: {
                color: colors[i],
              },
              data: [
                {
                  name: dataName[i],
                  value: res.data.data.series[i].value,
                },
              ],
              emphasis: {
                areaStyle: {
                  opacity: 0.3,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(17,95,234,1)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(17,95,234,0)',
                      },
                    ],
                  },
                },
              },
            }
            list.push(obj)
          }
          return list
        }
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            show: true,
            backgroundColor: 'rgba(17,95,234,0.3)',
            textStyle: {
              color: '#F0F0F0',
              fontSize: 10,
            },
            trigger: 'item',
            borderWidth: 0,
            padding: 0,
            axisPointer: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          },
          legend: {
            show: true,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            },
            position: {
              left: 'center',
              top: 'top',
            },
            left: 'right',
            top: 'top',
            data: dataName,
          },
          color: ['#115FEA', '#10EBE3', '#10A9EB', '#EB9C10', '#2E10EB', '#9B10EB'],
          radar: {
            shape: 'polygon',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                ],
              },
            },
            name: {
              color: '#FFF',
              padding: 0,
              rich: {
                a: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  lineHeight: 30
                },
                b: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#115FEA',
                  align: 'left'
                },
                c: {
                  fontSize: 14,
                  color: '#fff',
                  padding: [0, 10, 0, 5],
                  align: 'left'
                },
                d: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#10EBE3',
                  align: 'left'
                },
              }
            },
            axisNameGap: 10,
            indicator: scenicFacilities,
            center: ['50%', '50%'],
            radius: '75%',
          },
          series: updateChart()
        })
      })
    },
    // 热议品牌话题
    Chart4() {
      this.chart_4 = echarts.init(document.getElementById('wordCloudChart'))
      brandEvaluationGetBrandKeywordsCloud().then(res => {
        const data = res.data.data
        this.chart_4.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '100%',
              // 画布高
              height: '90%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })

    },
    // 点击区域时触发
    toggleSelect(item) {
      console.log(this.selectedItems, item)
      const index = this.selectedItems.findIndex(i => i.index === item.index);
      if (index > -1) {
        // 如果已经选中，则取消选中
        this.selectedItems.splice(index, 1);
      } else {
        // 如果未选中且数量小于5，则加入
        if (this.selectedItems.length < 5) {
          this.selectedItems.push(item);
        }
      }
    },
    removeSelectedItem(index) {
      this.selectedItems.splice(index, 1);
    },
    // 展示所有区域
    taskadd() {
      this.drawer = true
    },
    //对比开始
    async startContrast() {
      this.chart_1.clear()
      this.chart_2.clear()
      this.chart_3.clear()
      this.chart_4.clear()
      this.nameid = this.selectedItems.map(item => item.id)  // 收集对比的id
      this.dataTime.regionIds = this.nameid.join(',')
      console.log(this.dataTime)
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // this.seriesNameFirst1 = this.selectedItems[0].title
      // this.seriesNameFirst2 = this.selectedItems[1].title
      await this.myChartContrast()
      await this.myChartThan()
      await this.myChartRadarChart()
      await this.myChartWordCloudChart()
      loading.close();
      // this.myChartRadar()

    },
    // 景点各种参数选择后，也需要触发新的请求
    contrast(index) {
      this.categoryFilter = index.type
      this.dataTime.type = index.type
      brandEvaluationGetBrandIndex(this.dataTime).then(res => {
        var legend = res.data.data.map(item => item.name)
        var colors = [
          "#FF5733",
          "#33FF57",
          '#0f74fa',
          '#060351',
          '#f6d806',
        ];

        // 时间段
        var xAxisData = res.data.data[0].list.map(item => {
          return item.date
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              data: res.data.data[i].list.map(item => {
                return item.index
              }),
              type: 'bar',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: colors[i]},
                  {offset: 1, color: 'rgba(255, 255, 255, 0)'}
                ])
              }
            }
            list.push(obj)
          }
          return list
        }
        this.chart_2.setOption({
          backgroundColor: 'transparent',
          legend: {
            data: legend,
            left: "50%", // 图例组件离容器左侧的距离
            top: "2%",  // 图例组件离容器上侧的距离
            itemWidth: 8, // 图例组件的宽度
            itemHeight: 8, // 图例组件的高度
            icon: "stack", //icon 长方形 circle 圆形 arrow箭头型 diamond菱形
            textStyle: {
              color: colors, //自定义颜色
              fontSize: 12
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisTick: {
                alignWithLabel: true
              },
              // 设置所有标签都显示
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: '#C5D6E6'
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#C5D6E6'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(217,231,255,0.3)'
                }
              }
            }
          ],
          series: updateChart()
        })
      })
    },
    // 对比之后展示综合指数
    myChartContrast() {
      brandEvaluationBrandComprehensiveIndex(this.dataTime).then(res => {
        this.ComprehensiveIndex = res.data.data
        var legend = this.ComprehensiveIndex.map(item => item.name)

        var colors = [
          "#FF5733",
          "#33FF57",
        ];
        // 时间段
        var xAxisData = this.ComprehensiveIndex[0].list.map(item => {
          return item.date
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              type: 'line',
              itemStyle: {color: colors[i]},
              label: {show: false},
              data: this.ComprehensiveIndex[i].list.map(item => {
                return item.index        // 对应的值
              })
            }
            list.push(obj)
          }
          return list
        }
        this.chart_1.setOption({
          grid: {
            top: 70,
            bottom: 70,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          series: updateChart()
        })
      })
    },
    // 对比之后的景点知名度，景点质量等
    myChartThan() {
      brandEvaluationGetBrandIndex(this.dataTime).then(res => {
        var legend = res.data.data.map(item => item.name)
        var colors = [
          "#FF5733",
          "#33FF57",
          '#0f74fa',
          '#060351',
          '#f6d806',
        ];

        // 时间段
        var xAxisData = res.data.data[0].list.map(item => {
          return item.date
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              data: res.data.data[i].list.map(item => {
                return item.index
              }),
              type: 'bar',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color:  colors[i]},
                  {offset: 1, color: 'rgba(255, 255, 255, 0)'}
                ])
              }
            }
            list.push(obj)
          }
          return list
        }
        this.chart_2.setOption({
          backgroundColor: 'transparent',
          legend: {
            data: legend,
            left: "50%", // 图例组件离容器左侧的距离
            top: "2%",  // 图例组件离容器上侧的距离
            itemWidth: 8, // 图例组件的宽度
            itemHeight: 8, // 图例组件的高度
            icon: "stack", //icon 长方形 circle 圆形 arrow箭头型 diamond菱形
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisTick: {
                alignWithLabel: true
              },
              // 设置所有标签都显示
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: '#C5D6E6'
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#C5D6E6'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(217,231,255,0.3)'
                }
              }
            }
          ],
          series: updateChart()
        })
      })
    },
    // 对比之后 品牌维度
    myChartRadarChart() {
      brandEvaluationGetBrandDimensionRank(this.dataTime).then(res => {
        console.log(res)
        // 景点的数量
        const dataName = res.data.data.series.map(item => {
          return item.name
        })
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 景点各个配套设施
        const scenicFacilities = res.data.data.dimensions.map(item => (
            {
              name: item.name,
            }
        ))
        const updateChart = () => {
          const list = []
          for (let i = 0; i < dataName.length; i++) {
            const obj = {
              type: 'radar',
              symbolSize: 3,
              animation: true,
              lineStyle: {
                color: colors[i],
                width: 1,
              },
              itemStyle: {
                color: colors[i],
              },
              data: [
                {
                  name: dataName[i],
                  value: res.data.data.series[i].value,
                },
              ],
              emphasis: {
                areaStyle: {
                  opacity: 0.3,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(17,95,234,1)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(17,95,234,0)',
                      },
                    ],
                  },
                },
              },
            }
            list.push(obj)
          }
          return list
        }
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            show: true,
            backgroundColor: 'rgba(17,95,234,0.3)',
            textStyle: {
              color: '#F0F0F0',
              fontSize: 10,
            },
            trigger: 'item',
            borderWidth: 0,
            padding: 0,
            axisPointer: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          },
          legend: {
            show: true,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            },
            position: {
              left: 'center',
              top: 'top',
            },
            left: 'right',
            top: 'top',
            data: dataName,
          },
          color: ['#115FEA', '#10EBE3', '#10A9EB', '#EB9C10', '#2E10EB', '#9B10EB'],
          radar: {
            shape: 'polygon',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                ],
              },
            },
            name: {
              color: '#FFF',
              padding: 0,
              rich: {
                a: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  lineHeight: 30
                },
                b: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#115FEA',
                  align: 'left'
                },
                c: {
                  fontSize: 14,
                  color: '#fff',
                  padding: [0, 10, 0, 5],
                  align: 'left'
                },
                d: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#10EBE3',
                  align: 'left'
                },
              }
            },
            axisNameGap: 10,
            indicator: scenicFacilities,
            center: ['50%', '50%'],
            radius: '75%',
          },
          series: updateChart()
        })
      })
    },
    // 对比之后 词云图
    myChartWordCloudChart() {
      brandEvaluationGetBrandKeywordsCloud(this.dataTime).then(res => {
        const data = res.data.data
        this.chart_4.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '100%',
              // 画布高
              height: '90%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
    },

    getTime(value) {
      this.dataTime.startTime = value[0]
      this.dataTime.endTime = value[1]
    },
    handleResize() {
      this.chart_1.resize()
      this.chart_2.resize()
      this.chart_3.resize()
      this.chart_4.resize()

    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // 默认加载所有区域数据
    brandEvaluationCompareRegionList().then(res => {
      console.log(res)
      this.compareRegions = res.data.data
    })
    this.Chart1()   // 默认加载品牌综合指数
    this.Chart2()   // 默认品牌各类参数
    this.Chart3()   // 默认加载的品牌维度排名
    this.Chart4()  // 词语图
    loading.close();

    window.addEventListener('resize', this.handleResize);

  },

}
</script>

<style scoped lang="scss">
// 全局变量
$primary-color: #4291ff;
$secondary-color: #14c9c9;
$dark-bg: #0a0f1e;
$card-bg: rgba(10, 15, 30, 0.7);
$border-color: rgba(66, 145, 255, 0.3);
* {
  color: white;
  font-size: 14px;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  overflow: auto;
}

.flex-top {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.flex-top-child {
  width: 40%;
  margin-right: 10px;
  border-radius: 12px;
  background-color: $card-bg;
}

::v-deep .el-drawer {
  background-color: #1a2535 !important; /* 修改抽屉整体背景色 */
  color: white !important; /* 修改文字颜色 */
}

.grid-left-elDrawer {
  display: grid;
  grid-template-columns: repeat(3, 1fr)
}


.drawer-content {
  padding: 20px;
}

.grid-left-elDrawer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.el-button {
  background-color: transparent;
  border: 1px solid #409EFF;
  color: #409EFF;
  transition: all 0.3s ease;
  margin: 0 !important;

  &.active {
    background-color: #409EFF;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.selection-count {
  margin-top: 20px;
  font-size: 14px;
  color: #ccc;
}

.selected-container {
  margin-top: 20px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  color: white;
}

.placeholder {
  font-size: 14px;
  color: #999;
  margin-top: 10px;
}

.selected-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.brand-Comparison {
  display: flex;
  justify-content: space-between;
  height: 20%;
  width: 90%;
  margin: 5px auto 0 auto;

  li {
    background-color: rgba(255, 255, 255, 0.1);
    color: #409EFF;
    height: 100%;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.liChange {
  background-color: #409EFF !important;
  color: white !important;
}

.chart-filters {
  display: flex;
  gap: 8px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  //border-bottom: 1px solid $border-color;
}

.filter-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(.active) {
    background: rgba(255, 255, 255, 0.2);
  }

  &.active {
    background: $primary-color;
    color: white;
  }
}

.chart-panel {
  background: $card-bg;
  backdrop-filter: blur(10px);
  border-radius: 12px;
  //border: 1px solid $border-color;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }
}

.chart-width {
  width: 30%;
}

.chart-panel-width {
  width: 70%;
}
</style>
